module.exports = __webpack_public_path__ + "img/woodmaterial.332caede.jpeg";